import { ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';

export interface IBaseDisplayExprML {
	displayFormat: string;
}

export interface IDisplayExprML extends IBaseDisplayExprML {
	displayExpr: string[];
}

export interface IReadonlyBaseIDisplayExprML extends IBaseDisplayExprML {
	displayExpr: List<string>;
}

export type DisplayExprML = ReadonlyRecord<IReadonlyBaseIDisplayExprML>;

export const DisplayExprMLFactory = Record<IReadonlyBaseIDisplayExprML>({
	displayFormat: '',
	displayExpr: List()
});

export const DisplayExprMLFactoryFromJS = function (args: IDisplayExprML) {
	return DisplayExprMLFactory({
		displayFormat: args.displayFormat,
		displayExpr: List(args.displayExpr)
	});
};
